import { validateEmail } from '@perch-labs/warbler';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { VALIDATE_EMAIL as VALIDATE } from '~/services/validate-email/validate-email.queries';
import { IS_PERCH_ENERGY, LOGIN_URL } from '~/utils/constants';
import { sendToSegment } from '~/utils/tracking';

export const Email = (props: InputComponentProps) => {
  const validate = async ({ apollo, value }) => {
    if (!validateEmail(value)) return 'Please enter a valid email address';
    const { data } = await apollo.query({
      fetchPolicy: 'no-cache',
      query: VALIDATE,
      variables: { email: value },
    });

    if (data.validateEmail.userExists) {
      sendToSegment({
        type: 'email_already_exists_resulted',
        email: value,
      });

      return (
        <span>
          This email is already in use. Please <a href={LOGIN_URL}>sign in</a> instead.
        </span>
      );
    }

    if (!data.validateEmail.valid && data.validateEmail.validationErrorMessage) {
      return <span>{data.validateEmail.validationErrorMessage}</span>;
    }

    return true;
  };
  const emailPlaceholder = IS_PERCH_ENERGY ? 'example@perchenergy.com' : 'example@arcadia.com';
  return (
    <ValidatingInput
      autoComplete="username"
      label="Email"
      name="email"
      placeholder={emailPlaceholder}
      validate={validate}
      {...props}
    />
  );
};
